import { connect } from 'react-redux';

import { withRouter } from '../../components/WithRouter/WithRouter';

import { removeMod } from '../../actions/EditMod';
import { closeDialog } from '../../actions/Dialog';

import DialogConfirmationModRemove
    from '../../components/Dialogs/DialogConfirmationModRemove/DialogConfirmationModRemove';

const mapStateToProps = (state, ownProps) => ({
    id: ownProps.id,
    isDraftOrRejected: ownProps.isDraftOrRejected,
    history: ownProps.history,
})

const mapDispatchToProps = (dispatch) => ({
    onCloseDialog: () => {
        dispatch(closeDialog())
    },
    onSubmitDialog: (modVersionId, history, review) => {
        dispatch(removeMod(modVersionId, history, review))
        dispatch(closeDialog())
    },
})

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(DialogConfirmationModRemove)
)